import React from "react";
// #region types
import { ExportAttachmentViewProps } from "models/propTypes/revisorPropTypes";
import { TranslationKeys } from "translations";
// #endregion
// #region components
import { Grid } from "@mui/material";
import { StaticInfoMessage } from "components/common";
import ExportItemType from "./exportItemType";
// #endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ExportAttachmentsView: React.FC<ExportAttachmentViewProps> = (props) => {
  return (
    <Grid container direction={"column"} rowGap={3} className={cssExports.exportAttachmentsDialog}>
      <Grid item container direction={"column"} rowGap={1}>
        <Grid item className={cssExports.dialogContentTitle}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.ExportAttachmentsDialogDescription)}
        </Grid>
        <Grid item className={cssExports.dialogContentText}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.ExportAttachmentsDialogDescription2)}
        </Grid>
      </Grid>
      <Grid item container rowGap={2} direction={"column"}>
        {props.exportItemTypes.map((itemType, index) => (
          <Grid item key={index}>
            <ExportItemType {...itemType} />
          </Grid>
        ))}
      </Grid>
      <Grid item>
        <StaticInfoMessage>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.ExportConfirmationMessage)}
        </StaticInfoMessage>
      </Grid>
    </Grid>
  );
};

export default ExportAttachmentsView;
